

export function BSCourse() {
    return (
        <main id="main" className="site-main" role="main">
		   <article id="post-86" className="post-86 page type-page status-publish hentry">
			  <div className="entry-content">
				 <p data-adtags-visited="true"><strong>Topic 1: Bootstrap Introduction</strong></p>
				 <ul>
					<li>Bootstrap Overview</li>
					<li>Why Bootstrap</li>
					<li>Uses</li>
				 </ul>
				 <p data-adtags-visited="true"><strong>Topic 2: Bootstrap Containers</strong></p>
				 <ul>
					<li>Fixed Containers</li>
					<li>Fluid Containers</li>
					<li>Responsive Containers</li>
				 </ul>
				 <p data-adtags-visited="true"><strong>Topic 3: Bootstrap Grids</strong></p>
				 <ul>
					<li>Rows &amp; Columns</li>
					<li>2- columns</li>
					<li>Multi columns</li>
					<li>Responsive</li>
				 </ul>
				 <p data-adtags-visited="true"><strong>Topic 4: Bootstrap Typography &amp; Colors &amp; Buttons</strong></p>
				 <ul>
					<li>Display Headings</li>
					<li>Small, mark, Abbreviation, Etc</li>
					<li>Text contextual colors</li>
					<li>Back ground colors</li>
					<li>Buttons with contextual design</li>
					<li>Button Groups</li>
				 </ul>
				 <p data-adtags-visited="true"><strong>Topic 5: Bootstrap Images</strong></p>
				 <ul>
					<li>
					   Rounded
					   <ul>
						  <li>Circle</li>
					   </ul>
					   <ul>
						  <li>Thumbnail</li>
					   </ul>
					   <ul>
						  <li>Responsive</li>
					   </ul>
					   <ul>
						  <li>Image alignment</li>
					   </ul>
					</li>
				 </ul>
				 <p><strong>Topic 6: Bootstrap Tables</strong></p>
				 <ul>
					<li>Table header</li>
					<li>Table columns</li>
					<li>Responsive table</li>
					<li>Table contextual columns</li>
				 </ul>
				 <p><strong>Topic 7: Bootstrap Indication</strong></p>
				 <ul>
					<li>Progress bars &nbsp;</li>
					<li>Spinners</li>
					<li>Pagination</li>
					<li>Tooltip</li>
				 </ul>
				 <p><strong>Topic 8:</strong> <strong>Bootstrap</strong> <strong>Pagination</strong></p>
				 <ul>
					<li>Basic</li>
					<li>Active &amp; Disabled state</li>
					<li>Alignment</li>
					<li>Bread crumbs</li>
				 </ul>
				 <p><strong>Topic 9: Bootstrap Menus</strong></p>
				 <ul>
					<li>Navigation menu</li>
					<li>Navigation bars</li>
					<li>Dropdowns</li>
					<li>Collapse</li>
				 </ul>
				 <p><strong>Topic 10: Bootstrap Forms</strong></p>
				 <ul>
					<li>Basic form Input controls</li>
					<li>&nbsp;Form validations</li>
				 </ul>
				 <p><strong>Topic 11: Bootstrap Modal</strong></p>
				 <ul>
					<li>Basic Modal</li>
					<li>Animated Modal</li>
					<li>Scrolling Modal</li>
					<li>Popover</li>
				 </ul>
				 <p><strong>Topic 12: Bootstrap Toaster messages</strong></p>
				 <ul>
					<li>Basic Toaster message</li>
					<li>Contextual Toaster message</li>
				 </ul>
			  </div>
		   </article>
		</main>
    )
}